import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
declare let $: any

@Component({
  selector: 'app-notification-view-more',
  templateUrl: './notification-view-more.component.html'

})

export class NotificationViewMoreComponent implements OnInit {
  notification: boolean = true;
  AllNotCount: number = 0;
  selectedNotType: String = 'All';
  alertNotCount: number = 0;
  infoNotCount: number = 0;
  unreadCount: number = 0;
  enDataJson: any;
  allNotification: any[] = [];
  isLoading: boolean = true;
  userId: any;
  getNotification: any[];
  unreadNotifications: any[];
  currentUserData: any;
  requestTypes: String = '';
  cmdfailedDeviceName: String = '';
  sendCommanddto: SendCommandDto = new SendCommandDto();
  private modalRef: NgbModalRef | null = null;
  isPaymentDone: boolean = false;
  selectedValue: any;
  selectedNewValue: string = 'All';
  userTimezone: string;
  selectedLanguage: string = '';
  constructor(private translateService: TranslateService,
    private translate: TranslateService,
    private commonService: CommonService,
    private _service: ApiService,
    private router: Router,
    private _toastr: ToastrService,
    private modalService: NgbModal) {
    translate.addLangs(["en", "fr", "it", "ja"]);
    translate.setDefaultLang("en");
    translate.get(['DASHBOARD']).subscribe((values) => {
      this.enDataJson = Object.keys(values).map((key) => values[key]);
    });
  }
  ngOnInit(): void {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; // Fallback to UTC if not available
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translate.use(this.selectedLanguage);
    }

    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.currentUserData = JSON.parse(currentUser);
    }
    this.userId = this.currentUserData.id;
    this.getNotifications(this.userId);
  }
  groupedNotifications: {
    deviceName: string;
    date: String;
    time: String;
    deviceType: string;
    notifications: any[];
    category: String;
    settingType: String;
  }[] = [];

  changeGroupedNotifications: any;

  groupNotifications(data: any) {
    this.groupedNotifications = [];
    for (let notification of data) {
      const today: string = new Date().toISOString().split('T')[0];
      const today1 = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today1.getDate() - 1);
      const formattedDate = yesterday.toISOString().split('T')[0];
      if (notification.time === today) {
        notification.time = this.translateService.instant('DASHBOARD.TODAY');
        notification.notTime = this.getTimeDifferenceFromNow(notification.notTime);
      }
      if (notification.time === formattedDate) {
        notification.time = this.translateService.instant('DASHBOARD.YESTERDAY');
      }
      if (this.selectedValue === "Today" && notification.time === today) {
        notification.time = this.translateService.instant('DASHBOARD.TODAY');
        notification.notTime = this.getTimeDifferenceFromNow(notification.notTime);
      }

      let existingDevice = this.groupedNotifications.find(
        group => group.date === notification.time
      );
      if (existingDevice) {
        existingDevice.notifications.push(notification);
      } else {
        this.groupedNotifications.push({
          deviceName: notification.deviceName,
          date: notification.time,
          time: notification.notTime,
          deviceType: notification.deviceType,
          notifications: [notification],
          category: notification.notificationCat,
          settingType: notification.settingType
        });
      }
    }
  }

  newSelectType: any;
  selectNotificationType(type: String) {
    this.selectedNotType = type;
    this.selectedNewValue = 'All';
    // Refresh list for default
    this.groupedNotifications = [...this.allNotification];
    this.groupNotifications(this.groupedNotifications);
    this.AllNotCount = this.allNotification.length;
    this.alertNotCount = this.getNotification.filter(noti => noti.notificationCat === 'ALERT').length;
    this.infoNotCount = this.getNotification.filter(noti => noti.notificationCat === 'INFO').length;

    if (type === "Information") {
      this.changeGroupedNotifications = this.allNotification.filter(n => n.notificationCat === 'INFO');
      this.infoNotCount = this.changeGroupedNotifications.filter((a: { notificationCat: string; }) => a.notificationCat === 'INFO').length;
      this.groupNotifications(this.changeGroupedNotifications);
    } else if (type === "Alerts" && this.selectedNewValue == 'Yesterday') {
      this.alertNotCount = this.changeGroupedNotifications.filter((a: { notificationCat: string; }) => a.notificationCat === 'ALERT').length;
    }
  }


  enableSaveButton(event: Event) {
    if (event) {
      this.selectedNewValue = (event.target as HTMLSelectElement).value;
    } else {
      this.groupedNotifications = [...this.allNotification];
      this.groupNotifications(this.groupedNotifications);
    }
    if (this.selectedNewValue === 'All' && this.selectedNotType === "Information") {
      this.groupedNotifications = this.allNotification.filter(n => n.notificationCat === 'INFO');
      this.infoNotCount = this.groupedNotifications.length;
      this.groupNotifications(this.groupedNotifications);
    } else if (this.selectedNewValue === 'All' && this.selectedNotType === "Alerts") {
      this.groupedNotifications = this.allNotification.filter(n => n.notificationCat === 'ALERT');
      this.alertNotCount = this.groupedNotifications.length;
      this.groupNotifications(this.groupedNotifications);
    } else
      if (this.selectedNewValue === 'All' && this.selectedNotType === "All") {
        this.groupedNotifications = [...this.allNotification];
        this.AllNotCount = this.allNotification.length;
        this.groupNotifications(this.groupedNotifications);
      } else {
        this.changeGroupedNotifications = []
        if (this.selectedNotType === "Alerts" && (this.selectedNewValue == 'Yesterday' || this.selectedNewValue == 'Today')) {
          this.changeGroupedNotifications = this.allNotification.filter(n => n.time === this.selectedNewValue && n.notificationCat === 'ALERT');
          this.alertNotCount = this.changeGroupedNotifications.filter((a: { notificationCat: string; }) => a.notificationCat === 'ALERT').length;
        }
        if (this.selectedNotType === "All" && (this.selectedNewValue == 'Yesterday' || this.selectedNewValue == 'Today')) {
          this.changeGroupedNotifications = this.allNotification.filter(n => n.time === this.selectedNewValue);
          this.AllNotCount = this.changeGroupedNotifications.filter((a: { notificationCat: string; }) => a.notificationCat !== 'ALL').length;
        }
        if (this.selectedNotType === "Information" && (this.selectedNewValue == 'Yesterday' || this.selectedNewValue == 'Today')) {
          this.changeGroupedNotifications = this.allNotification.filter(n => n.time === this.selectedNewValue && n.notificationCat === 'INFO');
          this.infoNotCount = this.changeGroupedNotifications.filter((a: { notificationCat: string; }) => a.notificationCat == 'INFO').length;
        }
        this.groupNotifications(this.changeGroupedNotifications);
      }
  }

  // Helper to check if two dates are on the same calendar day
  isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }
  filterNotification(cat: String) {
    if (cat === 'ALERT') {
      this.groupNotifications(this.allNotification.filter(noti => noti.notificationCat === 'ALERT'));
    }
    else if (cat === 'INFO') {
      this.groupNotifications(this.allNotification.filter(noti => noti.notificationCat === 'INFO'));
    }
    else {
      this.groupNotifications(this.allNotification);
    }
  }
  markAsRead(notification: any) {
    try {
      if (notification?.notificationId !== undefined && notification.notificationId !== null) {
        const notificationdto = { notificationId: notification.notificationId, deviceType: notification.deviceType };
        this._service.postService(this._service.API_URL.saveNotificationTime, notificationdto).subscribe((response) => {
          if (response && response.status.code === 200) {
            notification.viewTime = new Date();
            this.unreadCount--;
          } else {
            this._toastr.error('', response.status.message)
          }
        })
      }
    }
    catch (error) {
      console.error('Error marking notification as read:', error);
    }
  }

  notificationConfig: { [key: string]: (notify: any) => string } = {
    SMART_PARENTING_WEB: notify =>
      this.translate.instant('NOTIFICATION.SMART_PARENTING_WEB', { category: notify.category }),
    WEB_SECURITY: notify =>
      this.translate.instant('NOTIFICATION.WEB_SECURITY', { category: notify.category }),
    SMART_PARENTING_APP: notify =>
      this.translate.instant('NOTIFICATION.SMART_PARENTING_APP', { appName: notify.appName }),
    INTUDER: notify =>
      this.translate.instant('NOTIFICATION.INTUDER', { intruderEmailId: notify.intruderEmailId }),
    THREAT: notify => {
      const appList = notify.appName?.split(',').join(', ');
      return this.translate.instant('NOTIFICATION.THREAT', { appName: appList });
    },
    SETTING_FAILURE: notify => {
      const types = notify.settingType?.split(',') || [];
      const translatedTypes = types.map((type: string) =>
        this.translate.instant('DASHBOARD.' + type.trim())
      );
      const joinedTypes = translatedTypes.join(', ');
      return this.translate.instant('NOTIFICATION.SETTING_FAILURE', {
        settingType: joinedTypes
      });
    },

    EXPIRY: (notify) => {
      if (notify.expiryStatus === 'LICENSE_EXPIRING_SOON') {
        const today = new Date();
        const expiryDate = new Date(today);
        expiryDate.setDate(today.getDate() + notify.expiryInDays + 1);
        const formattedDate = formatDate(expiryDate, 'MMM dd yyyy', 'en-US');

        return this.translate.instant('NOTIFICATION.EXPIRY_SOON', { date: formattedDate });
      }
      if (notify.expiryStatus === 'LICENSE_EXPIRED') {
        return this.translate.instant('NOTIFICATION.EXPIRED');
      }
    },

    PARENTAL_CONTROL_WEBSITE: notify =>
      this.translate.instant('NOTIFICATION.PARENTAL_CONTROL_WEBSITE', { website: notify.website }),
    BLOCK_HACKING_ATTEMPT: notify =>
      this.translate.instant('NOTIFICATION.BLOCK_HACKING_ATTEMPT', { action: notify.action }),
    RANSOMWARE_ALERT: notify =>
      this.translate.instant('NOTIFICATION.RANSOMWARE_ALERT', { file_name: notify.file_name }),
    PUA_APPLICATION_BLOCKED: notify =>
      this.translate.instant('NOTIFICATION.PUA_APPLICATION_BLOCKED', { adware: notify.adware }),
    VIRUS_REPAIRED: () =>
      this.translate.instant('NOTIFICATION.VIRUS_REPAIRED'),
    VIRUS_ACCESS_DENIED: notify =>
      this.translate.instant('NOTIFICATION.VIRUS_ACCESS_DENIED', { virus_detected: notify.virus_detected }),
    DATA_BACKUP_INSUFFICIENT_SPACE: () =>
      this.translate.instant('NOTIFICATION.DATA_BACKUP_INSUFFICIENT_SPACE'),
    INTRUSION_DETECTION_SYSTEM: () =>
      this.translate.instant('NOTIFICATION.INTRUSION_DETECTION_SYSTEM'),
    BROWSING_PROTECTION: notify =>
      this.translate.instant('NOTIFICATION.BROWSING_PROTECTION', { website: notify.website }),
    FIREWALL_WARNING: notify =>
      this.translate.instant('NOTIFICATION.FIREWALL_WARNING', { program_name: notify.program_name }),
    PHISHING_PROTECTION: notify =>
      this.translate.instant('NOTIFICATION.PHISHING_PROTECTION', { website: notify.website }),
    PARENTAL_CONTROL_APPLICATION: notify =>
      this.translate.instant('NOTIFICATION.PARENTAL_CONTROL_APPLICATION', { website: notify.application }),
    VIRUS_DELETED: () =>
      this.translate.instant('NOTIFICATION.VIRUS_DELETED'),
    EXPIRY_NOTIFICATION: (notify) => {
      if (notify.expiryStatus === 'LICENSE_EXPIRING_SOON') {
        const today = new Date();
        const expiryDate = new Date(today);
        expiryDate.setDate(today.getDate() + notify.expiryInDays + 1);
        const formattedDate = formatDate(expiryDate, 'MMM dd yyyy', 'en-US');

        return this.translate.instant('NOTIFICATION.EXPIRY_SOON', { date: formattedDate });
      }
      if (notify.expiryStatus === 'LICENSE_EXPIRED') {
        return this.translate.instant('NOTIFICATION.EXPIRED');
      }
    },
  };


  getTimeDifferenceFromNow(timeStr: string): string {
    const now = new Date();
    const [hours, minutes] = timeStr.split(':').map(Number);
    const givenTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      hours,
      minutes,
      0
    );
    const diffMs = now.getTime() - givenTime.getTime();
    const diffAbs = Math.abs(diffMs);
    const diffMinutes = Math.floor(diffAbs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const remainingMinutes = diffMinutes % 60;

    if (diffHours > 0) {
      return `${diffHours} hr${diffHours > 1 ? 's' : ''} ${remainingMinutes} min${remainingMinutes !== 1 ? 's' : ''}`;
    } else {
      return `${remainingMinutes} min${diffMinutes !== 1 ? 's' : ''}`;
    }
  }
  getNotificationMessage(notify: any): string {

    const autoFeatureOnLabels: Record<string, string> = {
      FIFTEEN_MINUTES: this.translate.instant('NOTIFICATION.AUTO_FEATURE_LABELS.FIFTEEN_MINUTES'),
      THIRTY_MINUTES: this.translate.instant('NOTIFICATION.AUTO_FEATURE_LABELS.THIRTY_MINUTES'),
      ONE_HOUR: this.translate.instant('NOTIFICATION.AUTO_FEATURE_LABELS.ONE_HOUR'),
      AFTER_REBOOT: this.translate.instant('NOTIFICATION.AUTO_FEATURE_LABELS.AFTER_REBOOT')
    };


    const uniqueSettingType = Array.from(
      new Set((notify.settingType ?? "").split(',').map((s: string) => s.trim()))
    ).join(', ');
    notify.settingType = uniqueSettingType;

    const type = notify.notificationType || notify.systemNotificationType;
    const notificationstypes = this.notificationConfig[type];
    if (notificationstypes) return notificationstypes(notify);

    if (!isNaN(Number(type)) && notify.featureName) {
      const readableName = this.translate.instant(notify.featureName);
      const status = notify.value === 1 ? 'NOTIFICATION.ON' : 'NOTIFICATION.OFF';
      let msg = this.translate.instant('NOTIFICATION.FEATURE_STATUS_CHANGED', {
        feature: readableName,
        status: this.translate.instant(status)
      });
      if (notify.value === 0 && notify.autoFeatureOn && notify.autoFeatureOn && notify.autoFeatureOn != 'TURN_ON') {
        const timeText = autoFeatureOnLabels[notify.autoFeatureOn];
        if (timeText) {
          const key = notify.autoFeatureOn === 'AFTER_REBOOT' ? 'NOTIFICATION.AUTO_FEATURE_ON_AFTER_REBOOT' : 'NOTIFICATION.AUTO_FEATURE_ON';
          msg += ' ' + this.translate.instant(key, { minutes: timeText });
        }

      }
      return msg;
    }

    return this.translate.instant('NOTIFICATION.UNKNOWN_TYPE');
  }
  camelCaseToTitle(camelCase: string): string {
    if (!camelCase) return '';
    return camelCase
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  getNotifications(userId: any) {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getAllNotifications + userId + '?timezone=' + this.userTimezone + '&selectedLang=' + this.selectedLanguage).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.getNotification = response.data;
          this.selectedNotType = 'All';
          this.AllNotCount = this.getNotification.length;
          this.alertNotCount = this.getNotification.filter(noti => noti.notificationCat === 'ALERT').length;
          this.infoNotCount = this.getNotification.filter(noti => noti.notificationCat === 'INFO').length;
          this.unreadNotifications = this.getNotification.filter(n => !n.viewTime);
          this.unreadCount = this.unreadNotifications.length;
          this.allNotification = this.getNotification;
          this.groupNotifications(this.getNotification);
        } else {
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.isLoading = false;
    }
  }


  translateRequestTypes(type: any) {
    return this.enDataJson[0][type];
  }

  openSendControlPopup(id: any, type: any, productType: any, deviceName: any) {
    this.sendCommanddto.deviceId = id;
    this.sendCommanddto.productKeyType = productType;
    this.cmdfailedDeviceName = deviceName;
    const items = type
      .split(',')
      .map((item: any) => item.trim())
      .filter((item: any) => item !== '');
    const uniqueItems = Array.from(new Set(items));
    this.requestTypes = uniqueItems.join(', ');
    this.sendCommanddto.settingFailureTypes = uniqueItems.join(', ');
    $("#controlRequestPopup").modal("show");
  }


  hideSendControlPopup() {
    $("#controlRequestPopup").modal("hide");
  }

  sendCommands() {
    try {
      this._service.postService(this._service.API_URL.resendFailedCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.hideSendControlPopup();
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  checkBeforeRenew(purchaseLink: string, type: string, crwDomainUrl: string) {
    if (type === "MOBSEC_ADVANCE") {
      $('#renewPopup').modal('show');
    } else {
      this.goToPurchaseUrl(purchaseLink, crwDomainUrl);
    }
  }
  goToPurchaseUrl(url: string, crwDomainUrl: string) {
    const newTab = window.open(url, '_blank');
    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess();
      } else {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentFailed();
      }
    };

    window.addEventListener('message', messageHandler);
  }

  handlePaymentSuccess(): void {
    this.isPaymentDone = true;
    this.modalRef?.close();
    //alert('Payment successful!');
    // Update license list or redirect
  }
  handlePaymentFailed(): void {
    this.modalRef?.close();
    //alert('Payment Failed!');
    // Update license list or redirect
  }

}
